<template>
    <div v-if="dataIsLoaded" class="min-w-screen min-h-screen flex items-center justify-center">
        <div v-if="tokenIsValid" class="w-[500px] h-auto bg-white rounded-lg px-[4rem] py-[3rem]">
            <form @submit.prevent="updatePhone">
                <p class="text-2xl mb-8">Обновите номер телефона</p>
                <PhoneInputComponent v-model:inputParam="phone" labelContent="Новый номер" ref="phoneInput" class="mb-6"/>
                <button @click="updatePhone" type="submit" class="w-full bg-custom-blue hover:bg-custom-blue-hover text-center text-white font-medium rounded-lg text-sm px-5 py-2 mb-8">Обновить</button>
            </form>
        </div>
        <div v-else class="w-[500px] h-auto bg-white rounded-lg px-[4rem] py-[3rem]">
            <p class="text-center">Похоже ссылка устарела</p>
            <p class="text-center">Попробуйте запросить письмо еще раз</p>
        </div>
    </div>
    <div v-else>
        <LoadingComponent/>
    </div>
</template>


<script>
    import { mapState } from 'vuex';

    import LoadingComponent from '@/components/LoadingComponent.vue';
    import PhoneInputComponent from '@/components/InputComponents/PhoneInputComponent.vue';

    export default {
        name: "ResetPhone",
        components: {
            LoadingComponent,
            PhoneInputComponent, 
        },
        computed: {
            ...mapState(["profileData"]),
        },
        data() {
            return {
                phone: null,
                tokenIsValid: false,
                dataIsLoaded: false,
                token: null,
            }
        },
        methods: {
            async checkToken() {
                const token = this.$route.query.token;
                if (!token) {
                    this.dataIsLoaded = true;
                    return;
                }

                const result = await this.$store.dispatch("checkToken", token);
                if (result.successfully) {
                    this.tokenIsValid = true;
                }
                this.token = token;
                this.dataIsLoaded = true;
            },
            validateData() {
                if (!this.phone) {
                    const phoneInput = this.$refs.phoneInput.$refs.phoneInput;
                    phoneInput.setCustomValidity("Введите новый номер телефона");
                    phoneInput.reportValidity();
                    return false;
                }
                if (!this.$globalMethods.validatePhone(this.phone)) {
                    const phoneInput = this.$refs.phoneInput.$refs.phoneInput;
                    phoneInput.setCustomValidity("Введите корретный номер телефона");
                    phoneInput.reportValidity();
                    return false;
                }
                return true;
            },
            async updatePhone() {
                if (!this.validateData()) {
                    return;
                }
                const data = {
                    temporary_token: this.token,
                    phone: this.phone,
                }
                let result = await this.$store.dispatch("resetPhone", data);
                if (result.successfully) {
                    result = await this.$store.dispatch("fetchProfileData");
                    this.$notify("Номер телефона успешно обновлен! Скоро вы будете перенаправлены на страницу входа...", "black");
                    setTimeout(() => {this.$router.push({name: "role"})}, 3000);
                } else {
                    if (result.detail == "User with the phone already exists.") {
                        const phoneInput = this.$refs.phoneInput.$refs.phoneInput;
                        phoneInput.setCustomValidity("Пользователь с таким номером телефона уже существует.");
                        phoneInput.reportValidity();
                    }
                }
            }
        },
        created() {
            this.checkToken();
        }
    }
</script>